import { Component } from '@angular/core';

@Component({
  selector: 'app-guide-enterprise-dashboard-configuration',
  templateUrl: './guide-enterprise-dashboard-configuration.component.html',
  styleUrls: ['./guide-enterprise-dashboard-configuration.component.scss']
})
export class GuideEnterpriseDashboardConfigurationComponent {

}
